var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-col flex-1",class:{
    'middle-presentation': true,
    'presenting-mode': _vm.isPresenting,
    'capture-mode': _vm.$store.state.isScreenCapture,
    'transparent-bg': _vm.slideActive.type == 'image' &&
      _vm.slideActive.imageType == 'background',
    'presenting-mode-share': _vm.isPresenting,
  },style:({'width': 'unset' })},[_c('div',{staticClass:"slide-intro",class:{
      [_vm.$store.state.currentSlideCanvas]: true,
      'flex flex-col': !_vm.isPresenting,
    },attrs:{"id":"middle-slide-intro"}},[_c('div',{staticClass:"ahaslide-legacy-css wrap-slide-intro vertical layout center center-justified",class:{'fit': _vm.isPresenting},attrs:{"id":"middle-canvas"}},[_c('SlideWrapperForSharingView',{on:{"selectPrevSlide":_vm.selectPrevSlide,"selectNextSlide":_vm.selectNextSlide,"handleNextSlideWhenPlayingQuiz":_vm.handleNextSlideWhenPlayingQuiz}}),_c('SharePresentationBar')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }